import React, { Component } from 'react';
import { Table, Button, Input, Select, Modal, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import SideNav from '../SideNav';
import '../style.less';

const { Option } = Select;

class CrcAgreeReportSummary extends Component {
    state = {
        data: [],
        loading: false,
        searchParams: {},
        defaultInv: null,
        invStatusList: [],
        exportVisible: false,
        exportParams: {},
        remarkVisible: false,
        remarkRecord: null,
        remarkValue: '',
        remarkSaving: false,
        pagination: {
            pageSize: 20,
            current: 1,
            showTotal: total => `共 ${total} 条`,
        },
    }

    componentDidMount() {
        //先查询当前人员可查看的项目,默认填充第一个,首屏只查该项目数据
        this.loadDefaultInvestigation();
        this.loadTypeConfigureList();
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ invStatusList: res.invStatusList || [] });
            },
        };
        $.sendRequest(options);
    }

    loadDefaultInvestigation = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryAuthCrcAgreeInvestigationList,
            data: {
                limit: 20,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                const defaultInv = datas[0] || null;
                const { searchParams } = this.state;
                if (defaultInv) {
                    searchParams.investigationName = defaultInv.investigationName;
                    searchParams.investigationId = defaultInv.investigationId;
                }
                this.setState({
                    searchParams,
                    defaultInv,
                }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryCrcAgreeReportSummaryList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    reset = () => {
        const { defaultInv } = this.state;
        const searchParams = {};
        //恢复默认填充的项目
        if (defaultInv) {
            searchParams.investigationName = defaultInv.investigationName;
            searchParams.investigationId = defaultInv.investigationId;
        }
        this.setState({
            searchParams,
        }, () => {
            this.search();
        });
    }

    handleChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleInvChange = (option) => {
        const { searchParams } = this.state;
        searchParams.investigationName = option ? option.text : undefined;
        searchParams.investigationId = option ? option.value : undefined;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    showRemarkModal = (record) => {
        this.setState({
            remarkVisible: true,
            remarkRecord: record,
            remarkValue: record.remark || '',
        });
    }

    handleRemarkChange = (e) => {
        this.setState({ remarkValue: e.target.value });
    }

    saveRemark = () => {
        const { remarkRecord, remarkValue } = this.state;
        this.setState({ remarkSaving: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.saveCrcAgreeRemark,
            data: {
                investigationId: remarkRecord.investigationId,
                investigationSiteId: remarkRecord.investigationSiteId,
                remark: remarkValue,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ remarkSaving: false, remarkVisible: false });
                if (res.success) {
                    message.success(res.success);
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ remarkSaving: false });
            },
        };
        $.sendRequest(options);
    }

    showExport = () => {
        const { searchParams } = this.state;
        //弹框自动带上列表当前搜索条件
        this.setState({
            exportVisible: true,
            exportParams: { ...searchParams },
        });
    }

    handleExportInvChange = (option) => {
        const { exportParams } = this.state;
        //弹框中项目简称可清除,清除后导出权限内全部项目
        exportParams.investigationName = option ? option.text : undefined;
        exportParams.investigationId = option ? option.value : undefined;
        this.setState({ exportParams });
    }

    handleExport = () => {
        const { exportParams, searchParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.contract.exportCrcAgreeReportSummary,
            data: {
                investigationId: exportParams.investigationId,
                fileName: searchParams.fileName,
                hasCrcAgree: searchParams.hasCrcAgree,
                uploadUserName: searchParams.uploadUserName,
                statusId: searchParams.statusId,
                siteIsCancel: searchParams.siteIsCancel,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ exportVisible: false });
                if (res.success) {
                    message.success(res.success);
                }
            },
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    renderEllipsis = text => (
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={text}>
            {text || ''}
        </div>
    )

    getColumns = () => {
        const isCsaRole = ['CSA', 'CSAL'].includes(sessionStorage.positionRole);
        const columns = [{
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 140,
        render: text => this.renderEllipsis(text),
    }, {
        title: 'JDE主项目号',
        dataIndex: 'mainJdeCode',
        key: 'mainJdeCode',
        width: 140,
    }, {
        title: '项目状态',
        dataIndex: 'invStatusNames',
        key: 'invStatusNames',
        width: 120,
        render: text => this.renderEllipsis(text),
    }, {
        title: '是否上传CRC协议',
        dataIndex: 'hasCrcAgree',
        key: 'hasCrcAgree',
        width: 130,
        render: text => text === 1 ? '是' : '否',
    }, {
        title: '文件名称',
        dataIndex: 'fileName',
        key: 'fileName',
        width: 220,
        render: text => this.renderEllipsis(text),
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 200,
        render: text => this.renderEllipsis(text),
    }, {
        title: '中心是否取消',
        dataIndex: 'siteIsCancel',
        key: 'siteIsCancel',
        width: 110,
        render: text => text === 1 ? '是' : '否',
    }, {
        title: '上传人员',
        dataIndex: 'uploadUserName',
        key: 'uploadUserName',
        width: 110,
        render: text => this.renderEllipsis(text),
    }, {
        title: '上传时间',
        dataIndex: 'uploadTime',
        key: 'uploadTime',
        width: 150,
    }, {
        title: '中心启动时间',
        dataIndex: 'actualSiteStartTimeStr',
        key: 'actualSiteStartTimeStr',
        width: 120,
    }, {
        title: '签署完成时间',
        dataIndex: 'actualCrcAgreeSignDateStr',
        key: 'actualCrcAgreeSignDateStr',
        width: 120,
    }, {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        width: 200,
        render: text => this.renderEllipsis(text),
    }];
        if (isCsaRole) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 100,
                fixed: 'right',
                render: (text, record) => <a onClick={() => this.showRemarkModal(record)}>设置备注</a>,
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item }));
        return dataSource;
    }

    render() {
        const { loading, pagination, searchParams, invStatusList, exportVisible, exportParams,
                remarkVisible, remarkValue, remarkSaving } = this.state;
        const isCsaRole = ['CSA', 'CSAL'].includes(sessionStorage.positionRole);
        return (
            <div className="content">
                <SideNav selectKey='crcAgreeReportSummary' />
                <div className="main">
                    <div className="search-bar">
                        <div className="search-item">
                            <label className="ui-label">项目简称</label>
                            <SearchRetrieve
                                keyword='investigationName'
                                style={{width: 160}}
                                placeholder='输入名称检索'
                                allowClear={true}
                                params={{limit: 20}}
                                url={API_URL.contract.queryAuthCrcAgreeInvestigationList}
                                config={{ id: 'investigationId', name: 'investigationName' }}
                                value={searchParams.investigationName}
                                onChange={this.handleInvChange}
                            />
                        </div>
                        <div className="search-item">
                            <label className="ui-label">项目状态</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 130}}
                                value={searchParams.statusId}
                                onChange={value => this.handleSelectChange(value, 'statusId')}
                            >
                                {invStatusList.map(d => <Option key={String(d.typeConfigureId)} value={d.typeConfigureId} title={d.typeValue}>{d.typeValue}</Option>)}
                            </Select>
                        </div>
                        <div className="search-item">
                            <label className="ui-label">文件名称</label>
                            <Input
                                placeholder="请输入"
                                style={{width: 160}}
                                value={searchParams.fileName}
                                onChange={e => this.handleChange(e, 'fileName')}
                            />
                        </div>
                        <div className="search-item">
                            <label className="ui-label">是否上传CRC协议</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 100}}
                                value={searchParams.hasCrcAgree}
                                onChange={value => this.handleSelectChange(value, 'hasCrcAgree')}
                            >
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                        <div className="search-item">
                            <label className="ui-label">上传人员</label>
                            <Input
                                placeholder="请输入"
                                style={{width: 120}}
                                value={searchParams.uploadUserName}
                                onChange={e => this.handleChange(e, 'uploadUserName')}
                            />
                        </div>
                        <div className="search-item">
                            <label className="ui-label">中心是否取消</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 100}}
                                value={searchParams.siteIsCancel}
                                onChange={value => this.handleSelectChange(value, 'siteIsCancel')}
                            >
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </div>
                        <div className="search-item">
                            <Button type="primary" onClick={this.search}>搜索</Button>
                            <Button type="primary" onClick={this.reset}>重置</Button>
                            <Button type="primary" onClick={this.showExport}>导出</Button>
                        </div>
                    </div>
                    <Table
                        loading={loading}
                        scroll={{x: isCsaRole ? 1860 : 1760}}
                        pagination={pagination}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        onChange={this.handleTableChange}
                        rowKey={record => record.investigationSiteId}
                    />
                    <Modal
                        title="导出CRC协议报表汇总"
                        visible={exportVisible}
                        width={440}
                        okText="下载"
                        cancelText="取消"
                        onOk={this.handleExport}
                        onCancel={() => this.setState({ exportVisible: false })}
                    >
                        <div className="search-item">
                            <label className="ui-label" style={{marginRight: '10px'}}>项目简称:</label>
                            <SearchRetrieve
                                keyword='investigationName'
                                style={{width: 240}}
                                placeholder='输入名称检索'
                                params={{limit: 20}}
                                url={API_URL.contract.queryAuthCrcAgreeInvestigationList}
                                config={{ id: 'investigationId', name: 'investigationName' }}
                                value={exportParams.investigationName}
                                onChange={this.handleExportInvChange}
                            />
                        </div>
                    </Modal>
                    <Modal
                        title="设置备注"
                        visible={remarkVisible}
                        confirmLoading={remarkSaving}
                        width={440}
                        okText="确定"
                        cancelText="取消"
                        onOk={this.saveRemark}
                        onCancel={() => this.setState({ remarkVisible: false })}
                    >
                        <Input.TextArea
                            rows={4}
                            maxLength={500}
                            placeholder="请输入备注(最多500字)"
                            value={remarkValue}
                            onChange={this.handleRemarkChange}
                        />
                    </Modal>
                </div>
            </div>
        )
    }
}

export default CrcAgreeReportSummary;



// WEBPACK FOOTER //
// ./src/components/contractManagement/crcAgreeReportSummary/index.js